<template>
    <div>
        <!-- Modal Component -->
        <b-modal ref="sectionModal" v-model="openModal" :title="modalTitle" size="lg" ok-title="Save Section" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" :ok-disabled="saving" :no-close-on-backdrop="true" scrollable>
            <div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Section Name: <i class="fa fa-asterisk text-danger small" v-if="!section.SectionName"></i></label>
                    <div class="col-sm-8">
                        <input type="text" v-model="section.SectionName" :class="{ 'is-invalid': errors.SectionName, 'form-control': true}" placeholder="Enter Section Name" />
                        <span v-if="errors.SectionName" class="text-danger">
                            <span v-for="error in errors.SectionName">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Display Order: <i class="fa fa-asterisk text-danger small" v-if="!section.DisplayOrder"></i></label>
                    <div class="col-sm-8">
                        <input type="number" v-model="section.DisplayOrder" :class="{ 'is-invalid': errors.DisplayOrder, 'form-control': true}" placeholder="Section Order" style="max-width: 200px;" />
                        <span v-if="errors.DisplayOrder" class="text-danger">
                            <span v-for="error in errors.DisplayOrder">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Active:</label>
                    <div class="col-sm-8">
                        <b-form-checkbox v-model="section.IsActive" value="1" unchecked-value="0" plain></b-form-checkbox>
                        <span v-if="errors.IsActive" class="text-danger">
                            <span v-for="error in errors.IsActive">{{ error }}</span>
                        </span>
                    </div>
                </div>
                <div class="row form-group">
                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Description:</label>
                    <div class="col-sm-8">
                        <textarea v-model="section.Description" :class="{ 'is-invalid': errors.Description, 'form-control': true}" placeholder="(optional). Section Description" style="min-height: 100px;"></textarea>
                        <span v-if="errors.Description" class="text-danger">
                            <span v-for="error in errors.Description">{{ error }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {

        data: function() {
            return {
                openModal: false,
                saving: false,
                section: {},
                errors: {},
                section: {},
            }
        },

        computed: {
            modalTitle(){
                if(this.section.InspectionSectionId)
                {
                    return 'Edit Section: '+this.section.SectionName;
                }

                //Default
                return 'New Section';
            }
        },

        watch: {
            section(newValue, oldValue){
                //Setter
                this.section = newValue;
            }
        },

        methods: {

            handleHide(bvEvt){
                //debugging
                if(this.$root.debug)
                {
                    //console.log('Hiding Modal');
                }
            },

            handleHidden(bvEvt){
                //Reset the values
                this.section = {};
                this.errors = {};
            },

            handleOk: function(bvEvt) {

               //Stops the modal from closing
               bvEvt.preventDefault();

               //Show loading?

               //Do it
               this.saveSection();
            },

            hideModal() {
                this.openModal = false;
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            setSection(section){
                //Set it
                this.section = section;
                this.showModal();
            },

            saveSection: function() {
                //Show loading
                this.saving = true;
                this.errors = {};

                //Send it
                this.$http
                .post('inspections/forms/section', this.section)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Form Section Saved');

                    //Emit the Data
                    this.$emit('sectionSaved', response.data);

                    //Hide it
                    this.hideModal();
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        this.$toastr.error(error.response.data);
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            },

        },

        mounted() {
            //Set the height
            //this.$refs.sectionModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';
        }
    }
</script>